import { useState } from "react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";

export default function ExportButton({ path, label = "Export CSV", size = "sm", testid = "export-csv-button" }) {
  const [loading, setLoading] = useState(false);
  const download = async () => {
    setLoading(true);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const match = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "");
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = match ? match[1] : "outlierpulse-export.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("CSV downloaded");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button variant="outline" size={size} onClick={download} disabled={loading} data-testid={testid}>
      {loading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Download className="h-4 w-4 mr-1.5" />} {label}
    </Button>
  );
}
